module.exports = __webpack_public_path__ + "static/media/nao-side.3b45d164.png";